import React, {useEffect, useState, useRef} from "react";
import PropTypes from "prop-types";
import { TabGroup } from "../layout/TabGroup";
import { useObjectList } from "./useObjectList";
import styles from "./placeArtMenu.scss";
import { Sidebar } from "../sidebar/Sidebar";
import { CloseButton } from "../input/CloseButton";
import { Button } from "../input/Button";
import { fetchMediums, fetchFrames } from "../../utils/artwork-utils";
import { MediaLoader } from "./MediaLoader";
import nextTick from "../../utils/next-tick";
import classNames from "classnames";
import { getInspectableAndPivot } from "../../systems/camera-system";


export function PlaceartSidebar({close, open}) {
    const [artwork, setArtwork] = useState({})
    const [mediums, setMedium] = useState([]);
    const [frames, setFrame] = useState([]);
    const { objects, selectedObject, toggleLights } = useObjectList();
    const [tabSelected, setTabSelected] = useState('Frames');

    const [loadArtwork, setLoadArtwork] = useState(false);
    const [loadArtworkQr, setLoadArtworkQr] = useState(false);
    const [loadSidebar, setLoadSidebar] = useState(false);

    const setMediums = async () => {
        try {
            setLoadSidebar(true);
            let data = await fetchMediums();
            setLoadSidebar(false);
            if (data && data.length > 0) {
            setMedium(data);
            }
        } catch (error) {
            setLoadSidebar(false);
            console.error('Failed to fetch mediums:', error);
        }
    }

    const setFrames = async () => {
        try {
            setLoadSidebar(true);
            let data = await fetchFrames();
            setLoadSidebar(false);
            if (data && data.length > 0) {
            setFrame(data);
            }
        } catch (error) {
            setLoadSidebar(false);
            console.error('Failed to fetch frames:', error);
        }
    }

    useEffect(() => {
        if(tabSelected == 'Mediums') setMediums();
        if(tabSelected == 'Frames') setFrames();
        
    }, [tabSelected])

    const changeMedium = async (medium) => {
        selectedObject.el.setAttribute("artwork", {
            mediumName: medium.name,
            glbModel: medium.model,
            completed: false,
            isDigitalFile: false
        });
    };

    const changeFrame = async(frame) => {
        selectedObject.el.setAttribute("artwork", {
            frame: frame.model,
            completed: false,
        });
    }

    const options = ["Mediums", "Frames"];

    const select = (selected) => {
        setTabSelected(options[selected])
    }

    const reset2DView = () => {
        toggleLights();
        toggleLights();
    }

    const resetCamera = async () => {
        if(!selectedObject.el || !selectedObject.el.hasAttribute("artwork")) return;
        await nextTick();
        const cameraSystem = document.querySelector("body > a-scene").systems['hubs-systems'].cameraSystem;
        await nextTick();
        selectedObject.el.object3D.updateMatrices();
        let viewDistance =  1.5;
        await nextTick();
        cameraSystem.resetCameraPivot(selectedObject.el, viewDistance);
        const { inspectable, pivot } = getInspectableAndPivot(selectedObject.el);


        cameraSystem.hideEverythingButThisObject(inspectable)
        
        setArtwork(selectedObject.el.components.artwork)
        if(selectedObject.el.components['artwork']?.data?.isDigitalFile) {
            setLoadArtworkQr(false);
            setLoadArtwork(false);
        }
    }

    const onClose = () => {
        close();
    }
    useEffect(() => {
        const artworkEl = selectedObject?.el;
        if(!artworkEl) return;

        function onArtworkLoading() {
            setLoadArtwork(true);
        }
    
        function onArtworkLoaded() {
            setLoadArtwork(false);
        }

        function onArtworkQRLoading() {
            setLoadArtworkQr(true);
        }
    
        function onArtworkQRLoaded() {
            setLoadArtworkQr(false);
        }

        artworkEl.addEventListener('reset-camera', resetCamera);
    
        artworkEl.addEventListener("model-loaded", onArtworkLoaded);
        artworkEl.addEventListener("load-start", onArtworkLoading);

        window.addEventListener("loaded-qr", onArtworkQRLoaded);
        window.addEventListener("load-qr", onArtworkQRLoading);
        
    
        return () => {
          artworkEl.removeEventListener('reset-camera', resetCamera);

          artworkEl.removeEventListener("model-loaded", onArtworkLoaded);
          artworkEl.removeEventListener("load-start", onArtworkLoading);

          window.removeEventListener("loaded-qr", onArtworkQRLoaded);
          window.removeEventListener("load-qr", onArtworkQRLoading);
        };
      }, []);
    
    return (
        <>
            {(loadArtwork || loadArtworkQr) && <MediaLoader></MediaLoader>}
            {open && (
            <Sidebar
            className={styles.placeartSidebar}
            afterTitle={<CloseButton 
                className={styles.close}
                onClick={onClose} />}
            >
                <TabGroup
                  theme="primary"
                  activeFilter={tabSelected}
                  list={options}
                  onSelectFacetIndex={select}
                ></TabGroup>
                <div style={{position:'relative'}}>
                    {loadSidebar && (
                    <div className={styles.contentLoader}>
                        <MediaLoader >

                        </MediaLoader>
                    </div>
                    )}
                    {!loadSidebar && (
                    <div style={{display:"flex", flexWrap:"wrap"}}>
                        
                        {tabSelected == 'Mediums' && 
                            mediums.filter(medium => medium.preview_sm)
                            .map(medium =>(
                            
                            <div className={classNames(styles.placeartBox, `${artwork?.data?.glbModel == medium.model.url ? 'active': ''}`)} onClick={() => changeMedium(medium)}>
                                <span>{medium.name}</span>
                                <img src={medium.preview_sm}></img>
                            </div>
                        ))}

                        {tabSelected == 'Frames' && frames.map(frame =>(
                            <div className={classNames(styles.placeartBox, `${artwork?.data?.frame == frame.model.url ? 'active': ''}` )} onClick={() => changeFrame(frame)}>
                                <span>{frame.name}</span>
                                <img src={frame?.preview_sm}></img>
                            </div>
                        ))}
                    </div>
                    )}
                </div>

            </Sidebar>
            )}

        </>
    )
  }